import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {TODAY_GIFT_SLICE_NAME} from '../constant';
import {TodayGiftState} from '../type';

const INITIAL_TODAY_GIFT_STATE: TodayGiftState = {
  isUpdated: false,
};

export const todayGiftSlice = createSlice({
  name: TODAY_GIFT_SLICE_NAME,
  initialState: INITIAL_TODAY_GIFT_STATE,
  reducers: {
    setIsUpdated: (state, action: PayloadAction<boolean>) => {
      state.isUpdated = action.payload;
    },
  },
});

export const {setIsUpdated} = todayGiftSlice.actions;
